import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { FormControl } from '@angular/forms';

import { injectModalRef } from '../../../../shared/modal';
import { NotificationService } from '../../../../core/services';

export interface BackupCodesModalData {
  codes: string[];
}

@Component({
  selector: 'app-backup-codes-modal',
  standalone: false,
  templateUrl: './backup-codes-modal.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BackupCodesModal {
  readonly data = input.required<BackupCodesModalData>();
  readonly modalRef = injectModalRef<void>();

  private readonly notificationService = inject(NotificationService);

  protected readonly saved = new FormControl(false, { nonNullable: true });

  constructor() {
    this.modalRef.setCanClose(() => {
      if (this.saved.value) return true;
      this.notificationService.error('Confirm you saved your backup codes before closing this.');
      return false;
    });
  }

  protected copy(): void {
    navigator.clipboard?.writeText(this.data().codes.join('\n'))
      .then(() => this.notificationService.success('Backup codes copied to clipboard.'))
      .catch(() => this.notificationService.error('Could not copy backup codes.'));
  }

  protected download(): void {
    const blob = new Blob([this.data().codes.join('\n') + '\n'], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'mila-backup-codes.txt';
    link.click();
    URL.revokeObjectURL(url);
  }
}
